import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { LOGOUT_CLIENT_PANEL, LOGOUT_CLIENT_PANEL_SUCCESS, LOGOUT_CLIENT_PANEL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* logoutClientPanel({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.urlParams;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/client/user/${userId}/end-customer-session`,
      method: 'POST',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: LOGOUT_CLIENT_PANEL_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LOGOUT_CLIENT_PANEL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LOGOUT_CLIENT_PANEL_ERROR, payload: error });
  }
}

export function* watchlogoutClientPanel() {
  yield takeEvery(LOGOUT_CLIENT_PANEL, logoutClientPanel);
}

function* logoutClientPanelSaga() {
  yield all([fork(watchlogoutClientPanel)]);
}

export default logoutClientPanelSaga;
